module.exports = __webpack_public_path__ + "img/c00_buildingtechhydraulicmining_Normal_ua.2456b476.webp";